<template>
<div class="chapter">
<div class="inner_page">
<p class="dedit"><a id="page_ii"></a><em class="italic">For Susan M. Terner, first reader, editor extraordinaire, and in all ways, my secret weapon</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?7a5c2043